import { formatDisplayDateTime } from "@core/helper/formatDisplayDateTime";

/** @deprecated Prefer formatDisplayDateTime directly. */
export const showDate = (dateTime) =>
  formatDisplayDateTime(dateTime, { pattern: "full", input: "auto" });

export const list_to_tree = (list) => {
  var map = {},
    node,
    roots = [],
    res = [],
    i,
    j;

  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i;
    list[i].children = [];
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parentId !== null) {
      list[map[node.parentId]].children.push(node);
    } else {
      roots.push(node);
    }
  }

  for (i = 0; i < roots.length; i += 1) {
    node = roots[i];

    if (node.children.length === 0) {
      delete node.children;
      res.push(node);
    } else {
      for (j = 0; j < node.children.length; j += 1) {
        var item = node.children[j];
        if (item.children.length === 0) {
          delete item.children;
        }
      }
      res.push(node);
    }
  }

  return res;
};

export const covertToPersianDateTime = (item) => {
  if (item && item !== undefined) {
    return formatDisplayDateTime(item, { pattern: "YYYY/MM/DD H:mm", input: "iso" });
  } else {
    return "";
  }
};

export const getAppEnv = () => {
  if (typeof window !== "undefined" && window.env) {
    return window.env;
  }
  return {};
};

export const getCaptchaConfig = () => {
  const envCaptcha = getAppEnv().captcha;
  if (envCaptcha?.siteKey) {
    return envCaptcha;
  }

  return {
    captchaType: process.env.REACT_APP_CAPTCHA_TYPE || "recaptcha",
    siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || "",
  };
};

export const recaptchaSiteKey = () => getCaptchaConfig().siteKey?.trim() || "";

export const isRecaptchaEnabled = () => {
  const { captchaType, siteKey } = getCaptchaConfig();
  return captchaType === "recaptcha" && Boolean(siteKey?.trim());
};

/** @deprecated use recaptchaSiteKey() */
export const siteKey = () => recaptchaSiteKey();

export const getAppConfig = () => getAppEnv().app || {};

export const getAppDomain = () =>
  getAppConfig().domain?.trim() || process.env.REACT_APP_DOMAIN?.trim() || "";

export const getExchangeSlug = () => {
  const slug = getAppConfig().exchangeSlug?.trim();
  if (slug) {
    return slug.toLowerCase();
  }

  const domain = getAppDomain();
  if (!domain) {
    return "fibitex";
  }

  return domain.split(".")[0].toLowerCase();
};

export const getBrandDisplayName = () => {
  const brand = getAppConfig().brandName?.trim();
  if (brand) {
    return brand;
  }

  const slug = getExchangeSlug();
  return slug.charAt(0).toUpperCase() + slug.slice(1);
};

export const showLanding = () => {
  const value = getAppEnv().showLanding;
  return value === true || value === "true";
};
